{
  "tabs": {
    "chat": "Чат",
    "reminders": "Еске салғыштар",
    "calendar": "Күнтізбе",
    "settings": "Баптаулар"
  },
  "common": {
    "cancel": "Болдырмау",
    "save": "Сақтау",
    "confirm": "Растау",
    "delete": "Жою",
    "back": "Артқа",
    "close": "Жабу",
    "edit": "Өңдеу",
    "search": "Іздеу",
    "all": "Барлығы",
    "loading": "Жүктелуде...",
    "error": "Қате болды",
    "notFound": "Табылмады",
    "tryAgain": "Қайта көріңіз",
    "retry": "Қайталау",
    "undo": "Болдырмау",
    "pullToRefresh": "Жаңарту үшін тартыңыз",
    "justNow": "қазір ғана"
  },
  "auth": {
    "welcome": "FishMemory-ға қош келдіңіз",
    "tagline": "Сіздің WhatsApp еске салғыш көмекшіңіз, енді қалтаңызда.",
    "subtitle": "Сіздің WhatsApp еске салғыш көмекшіңіз, енді қалтаңызда.",
    "phoneLabel": "Сіздің WhatsApp нөміріңіз",
    "phoneHint": "Біз WhatsApp арқылы растау кодын жібереміз",
    "invalidPhone": "Дұрыс телефон нөмірін енгізіңіз",
    "continue": "Жалғастыру",
    "enterPhone": "WhatsApp нөміріңізді енгізіңіз",
    "phonePlaceholder": "Телефон нөмірі",
    "sendCode": "Код жіберу",
    "verifyTitle": "Нөмірді растау",
    "otpSentTo": "{{phone}} нөміріне WhatsApp арқылы 6 таңбалы код жіберілді",
    "enterFullCode": "Барлық 6 таңбаны енгізіңіз",
    "invalidOtp": "Қате код. Қайта көріңіз.",
    "otpFailed": "Код жіберу сәтсіз аяқталды. Қайта көріңіз.",
    "otpResent": "Код қайта жіберілді",
    "resendIn": "{{seconds}}с ішінде қайта жіберу",
    "resendCode": "Кодты қайта жіберу",
    "enterOtp": "WhatsApp-қа жіберілген кодты енгізіңіз",
    "verify": "Растау",
    "resend": "Кодты қайта жіберу",
    "wrongNumber": "Қате нөмір?",
    "backToPhone": "Телефонға қайту",
    "editPhone": "Телефон нөмірін өңдеу",
    "error": "Қате",
    "setupTitle": "Баптауды бастайық",
    "setupSubtitle": "Осы баптауларды кейін Баптаулардан өзгерте аласыз",
    "namePlaceholder": "Атыңыз",
    "letsGo": "Баптауды аяқтау",
    "skipForNow": "Қазір өткізіп жіберу"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "Хабарлама жазыңыз...",
    "inputPlaceholder": "Хабарлама жазыңыз...",
    "typing": "FishMemory теріп жатыр...",
    "online": "Желіде",
    "connecting": "Қосылуда...",
    "reconnecting": "Қайта қосылуда...",
    "offline": "Желіде жоқ",
    "empty": "Әңгіме бастаңыз",
    "emptyHint": "Еске салғыштар жасаңыз, кестеңізді тексеріңіз немесе көмек сұраңыз.",
    "emptyAction": "Үлгі еске салғыш жіберу",
    "actions": "Чат әрекеттері",
    "keep": "Хабарламаларды сақтау",
    "clearTitle": "Чатты тазалау",
    "clearConfirm": "Бұл құрылғыдан барлық хабарламаларды жою? Бұл қайтарылмайды.",
    "clear": "Чатты тазалау",
    "optionSelected": "Таңдалған: {{label}}",
    "sendingSelection": "Жіберілуде...",
    "connectionLost": "Қайта қосылуда..."
  },
  "reminders": {
    "title": "Менің еске салғыштарым",
    "active": "Белсенді",
    "today": "Бүгін",
    "thisWeek": "Осы апта",
    "history": "Тарих",
    "items": "элементтер",
    "emptyTitle": "Әлі еске салғыш жоқ",
    "emptySubtitle": "Чаттан жасап, мұнда көресіз.",
    "emptyAction": "Чатты ашу",
    "filterActive": "Белсенді",
    "filterToday": "Бүгін",
    "filterWeek": "Осы апта",
    "filterHistory": "Тарих",
    "emptyState": "Еске салғыш жоқ. Әңгіме бастаңыз!",
    "swipeDone": "Аяқталды",
    "swipeSnooze": "Кешіктіру",
    "swipeDelete": "Жою",
    "search": "Еске салғыштарды іздеу...",
    "upcoming": "Жақында",
    "completed": "Аяқталды",
    "overdue": "Уақыты өтті",
    "tomorrow": "Ертең",
    "synced": "{{value}} синхрондалды",
    "swipeHint": "Қосымша әрекеттер үшін еске салғышты сырғытыңыз",
    "noResults": "Іздеу бойынша еске салғыш табылмады",
    "noResultsHint": "Басқа сөзбен көріңіз немесе іздеуді тазалаңыз",
    "deleteAllFailed": "Барлық еске салғыштарды жою сәтсіз аяқталды"
  },
  "calendar": {
    "title": "Күнтізбе",
    "today": "Бүгін",
    "tomorrow": "Ертең",
    "completed": "аяқталды",
    "noEvents": "Жоспар жоқ",
    "noEventsSubtitle": "Еске салғыштар мен оқиғаларды көру үшін күн таңдаңыз.",
    "googleEvent": "Google Күнтізбесі",
    "legendActive": "Белсенді",
    "legendRecurring": "Қайталаушы",
    "legendDone": "Аяқталды",
    "legendGoogle": "Google",
    "previousMonth": "Өткен ай",
    "nextMonth": "Келесі ай",
    "previousYear": "Өткен жыл",
    "nextYear": "Келесі жыл",
    "goToToday": "Бүгінге өту",
    "all": "Барлығы",
    "active": "Белсенді",
    "done": "Аяқталды",
    "paused": "Үзілісте"
  },
  "settings": {
    "title": "Баптаулар",
    "profile": "Профиль",
    "name": "Көрсетілетін аты",
    "enterName": "Атыңызды енгізіңіз",
    "language": "Тіл",
    "uiLanguage": "Қосымша тілі",
    "uiLanguageHelp": "Тек осы құрылғыдағы қосымша интерфейсі, күнтізбе белгілері және орналасу бағытын өзгертеді.",
    "serverLanguage": "Чат тілі",
    "serverLanguageHelp": "Сервер жауаптары мен еске салғыш хабарламаларының тілін өзгертеді.",
    "timezone": "Уақыт белдеуі",
    "currentTimezone": "Ағымдағы уақыт белдеуі",
    "timezoneHelp": "Барлық еске салғыш уақыттары осы уақыт белдеуінде көрсетіледі.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "Уақыт белдеуін сақтау",
    "timezoneSaved": "Уақыт белдеуі жаңартылды",
    "detect": "Анықтау",
    "detectFailed": "Уақыт белдеуін анықтау мүмкін болмады",
    "autoDetect": "GPS арқылы автоматты анықтау",
    "notifications": "Хабарламалар",
    "notificationsHelp": "Қайталау еске салғыштары еске салғыш жеткізілгеннен кейінгі қайталанатын ескертулерді басқарады. Құрылғы деңгейіндегі хабарлама рұқсаттары телефон баптауларында басқарылады.",
    "pushEnabled": "Хабарламалар қосулы",
    "autoDoneOnFire": "Жіберілгенде автоматты аяқтау",
    "autoDoneOnFireDesc": "Өшірілгенде, еске салғыштар сіз аяқталған деп белгілегенше белсенді қалады.",
    "googleCalendar": "Google Күнтізбесі",
    "google": "Google Күнтізбесі",
    "googleConnected": "Қосылған",
    "googleDisconnected": "Қосылмаған",
    "googleConnectedHelp": "Жаңа еске салғыштар күнтізбеге автоматты түрде синхрондалады.",
    "googleDisconnectedHelp": "Еске салғыштар мен оқиғаларды үйлестіру үшін Google Күнтізбесін қосыңыз.",
    "googleConnectFailed": "Google Күнтізбесіне қосылу сәтсіз аяқталды",
    "connected": "Қосылған",
    "disconnected": "Қосылмаған",
    "connect": "Қосу",
    "disconnect": "Өшіру",
    "autoSync": "Жаңа еске салғыштарды автоматты синхрондау",
    "autosync": "Жаңа еске салғыштарды автоматты синхрондау",
    "subscription": "Жазылым",
    "trialUsed": "Сынақ: {{used}}/{{total}} пайдаланылды",
    "trialStatus": "Сынақ қолжетімді",
    "activeStatus": "Жазылым белсенді",
    "expiredStatus": "Жазылым мерзімі аяқталған",
    "unsubscribedStatus": "Жазылым жоқ",
    "about": "Ақпарат",
    "version": "Нұсқа",
    "logout": "Шығу",
    "logoutTitle": "Шығу",
    "logoutConfirm": "Шығуға сенімдісіз бе?",
    "noName": "Аты орнатылмаған",
    "serverConnection": "Серверге қосылу",
    "serverUrl": "Сервер URL",
    "serverEdit": "Өңдеу",
    "saveReconnect": "Сақтап, қайта қосылу",
    "resetDefault": "Әдепкіге қайтару",
    "invalidServerUrlTitle": "Жарамсыз сервер URL",
    "invalidServerUrlMessage": "Дұрыс http немесе https сервер URL енгізіңіз, мысалы https://example.com",
    "uiLanguageChangeFailed": "Қосымша тілін өзгерту сәтсіз аяқталды. Қайта көріңіз.",
    "serverLanguageChangeFailed": "Чат тілін өзгерту сәтсіз аяқталды. Қайта көріңіз.",
    "timezoneChangeFailed": "Уақыт белдеуін өзгерту сәтсіз аяқталды. Қайта көріңіз.",
    "autoSyncChangeFailed": "Авто-синхрондауды жаңарту сәтсіз аяқталды. Қайта көріңіз.",
    "nameChangeFailed": "Көрсетілетін атты жаңарту сәтсіз аяқталды. Қайта көріңіз.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "Еске салғыш мәліметтері",
    "editTime": "Уақытты өңдеу",
    "rename": "Атын өзгерту",
    "snooze": "Кешіктіру",
    "snooze15": "15 минутқа кешіктіру",
    "pause": "Үзу",
    "pauseReminder": "Еске салғышты үзу",
    "resume": "Қайта бастау",
    "resumeReminder": "Еске салғышты қайта бастау",
    "skip": "Келесіге өткізу",
    "skipOccurrence": "Осы жағдайды өткізу",
    "syncGoogle": "Google-ға синхрондау",
    "delete": "Жою",
    "deleteTitle": "Еске салғышты жою",
    "deleteConfirm": "Бұл еске салғыш тұрақты түрде жойылады.",
    "deleteRecurringTitle": "Қайталаушы еске салғышты жою",
    "deleteRecurringMessage": "Осы жағдайды өткізу немесе бүкіл серияны жоюды қалайсыз ба?",
    "deleteThisOccurrence": "Осы жағдайды өткізу",
    "deleteEntireSeries": "Бүкіл серияны жою",
    "done": "Аяқталды",
    "markDone": "Аяқталды деп белгілеу",
    "undo": "Қалпына келтіру",
    "undoPrompt": "Қайта белсендіру керек пе? Қазір қалпына келтіріңіз.",
    "recurring": "Қайталаушы",
    "nextRun": "Келесі іске қосу",
    "oneTime": "Бір реттік",
    "pending": "Күтуде",
    "sent": "Жіберілді",
    "paused": "Үзілісте",
    "active": "Белсенді",
    "snoozed": "Кешіктірілді",
    "localTime": "Жергілікті уақытпен көрсетілген",
    "recurrence": "Қайталау",
    "created": "Жасалған",
    "tags": "Тегтер",
    "fireCount": "Қанша рет іске қосылды",
    "actions": "Әрекеттер",
    "none": "Жоқ",
    "snoozeFailed": "Еске салғышты кешіктіру сәтсіз аяқталды",
    "pauseFailed": "Еске салғышты үзу сәтсіз аяқталды",
    "resumeFailed": "Еске салғышты қайта бастау сәтсіз аяқталды",
    "skipFailed": "Еске салғышты өткізу сәтсіз аяқталды",
    "doneFailed": "Еске салғышты аяқталды деп белгілеу сәтсіз аяқталды",
    "undoFailed": "Еске салғыш күйін қалпына келтіру сәтсіз аяқталды",
    "deleteFailed": "Еске салғышты жою сәтсіз аяқталды",
    "rescheduleTitle": "Қайта жоспарлағыңыз келе ме?",
    "rescheduleMsg": "Бұл еске салғыштың уақыты өтіп кетті. Қайта жоспарлағыңыз келе ме?",
    "reschedule15": "15 минуттан кейін",
    "reschedule60": "1 сағаттан кейін",
    "keepOverdue": "Өзгеріссіз қалдыру"
  },
  "onboarding": {
    "slide1Title": "FishMemory-ға қош келдіңіз",
    "slide1Sub": "Сіздің жеке еске салғыш көмекшіңіз — WhatsApp арқылы және қалтаңызға арналған.",
    "slide2Title": "Табиғи сөйлесіңіз",
    "slide2Sub": "\"Ертең сағат 3-те анама қоңырау шалуды еске сал\" деп жазыңыз — қалғанын біз жасаймыз.",
    "slide3Title": "Ешнәрсені ұмытпаңыз",
    "slide3Sub": "Уақытылы хабарламалар алыңыз, тегтермен ұйымдастырыңыз және маңызды нәрселерді бақылауда ұстаңыз.",
    "getStarted": "Бастау",
    "next": "Келесі",
    "firstReminderTitle": "Алғашқы еске салғышыңызды жасаңыз!",
    "firstReminderHint": "Мысалы, былай жазыңыз:",
    "firstReminderExample": "Ертең сағат 9-да су ішуімді еске сал",
    "gotIt": "Түсіндім!",
    "notifRationaleTitle": "Уақытында болыңыз",
    "notifRationaleBody": "FishMemory уақтылы еске салу үшін хабарламаларға мұқтаж. Сіз тек жасаған еске салғыштар үшін хабарламалар аласыз.",
    "notifRationaleAllow": "Хабарламаларды қосу",
    "notifRationaleLater": "Кейінірек",
    "swipeHint": "Жылдам әрекеттер үшін оңға сырғытыңыз →",
    "calendarDragHint": "Кеңейту үшін сүйреңіз ↕"
  }
}
